<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1 myp" id="شكر-وتقدير">
<p style="text-indent:01em"><strong><span dir="rtl">تنويه:</span></strong></p>
<br/><br/>
<p style="text-indent:01em"><span dir="rtl">كلُّ أحداث هذه الرواية هي مِن وحي خيال الكاتبة، ولا تمتُّ للحقيقة بِصِلة.</span></p>
<p style="text-indent:01em"><span dir="rtl"><span style="text-decoration:underline !important;">الحديث ذو الخط في الأسفل هو حديث داخلي</span>، <strong>والحديث البارز هو الحديث المسموع.</strong></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?45ce9fe0